<template>
  <VerifySmsModal
    v-if="isShowed"
    v-model="code"
    :phone="phone"
    :error="codeWrong"
    @sendSms="onSendSms"
    @sendCode="onSendCode"
    @close="isShowed = false"
  />
</template>
<script>
import { onUnmounted, ref, watch, defineAsyncComponent } from 'vue';
import { appEmitter } from '../../emitter';
import { SmsEvent } from '../../assets/js/vue/utlis/captcha/config';
import { sendCode, verifyCode } from '../../api/sms';
import { useOtpStore } from '../../store/useOtpStore';
import { useConfirmModalStore } from '../../store/useConfirmModalStore';

/**
 * Ловит событие CaptchaEvent.ON_GET_PHONE_CODE и открывает модалку с капчей и вводом телефона
 * если модалка успешно закрывается отправляет событие об успешном подтверждении смс
 * 
 * только для использования в лейауте
 */
export default {
  name: 'GetPhoneCodeModal',
  components: {
    VerifySmsModal: defineAsyncComponent(() => import('../../components-manual/VerifySmsModal.vue')),
  },
  setup() {
    const isShowed = ref(false);
    const phone = ref('');
    const endpoint = ref('');
    const code = ref('');

    const {
      isSendSmsCodePending,
      isSendSmsPending,
      isSendSmsAvailable,
      verifiedPhone,
      checkVerify,
      startTimer,
      startAttemptTimer,
      open,
      close,
    } = useOtpStore();
    const { open: confirmModalOpen } = useConfirmModalStore();

    const onGetPhoneCodeHandler = async (payload) => {
      if (payload.force) verifiedPhone.value = '';
      if (await checkVerify(payload.phone)) {
        appEmitter.emit(SmsEvent.ON_CONFIRMED);
        return;
      }
      phone.value = payload.phone;
      endpoint.value = payload.endpoint;
      isShowed.value = true;
    }

    appEmitter.on(SmsEvent.ON_GET_PHONE_CODE, onGetPhoneCodeHandler);

    onUnmounted(() => {
      appEmitter.off(SmsEvent.ON_GET_PHONE_CODE, onGetPhoneCodeHandler);
    });

    const clearModal = async () => {
      phone.value = '';
      endpoint.value = '';
      code.value = '';
    };

    const showErrorTooMayRequests = (time = 'минуту') => confirmModalOpen({
      title: 'Внимание!',
      description: `Превышен допустимый лимит запросов по указанному номеру телефона.<br>Повторите попытку через ${time}.`,
      buttonClose: 'Понятно'
    });

    const onSendSms = async () => {
      codeWrong.value = false;
      isSendSmsPending.value = true;
      await sendCode(phone.value, endpoint.value)
        .then(() => {
          startTimer();
        })
        .catch((e) => {
          if (e.response?.status === 429) {
            showErrorTooMayRequests();
            startTimer();
          }
          // TODO handle other exeptions
        })
        .finally(() => {
          isSendSmsPending.value = false;
        });
    };

    watch(isShowed, (val) => {
      if (val) {
        open();
        if (isSendSmsAvailable.value) onSendSms();
      } else {
        close();
        clearModal();
        appEmitter.emit(SmsEvent.ON_CLOSED);
      }
    });

    const codeWrong = ref(false);
    watch(code, () => {
      codeWrong.value = false;
    });

    const onSendCode = async () => {
      isSendSmsCodePending.value = true;
      await verifyCode(code.value, endpoint.value)
        .then(() => {
          appEmitter.emit(SmsEvent.ON_CONFIRMED);
          isShowed.value = false;
          verifiedPhone.value = phone.value;
        })
        .catch((e) => {
          codeWrong.value = true;
          if (e.response?.status === 429) {
            startAttemptTimer();
          }
          // TODO handle other exeptions
        })
        .finally(() => {
          isSendSmsCodePending.value = false;
        });
    };

    return {
      isShowed,
      phone,
      endpoint,
      onSendCode,
      onSendSms,
      codeWrong,
      code,
    };
  },
};
</script>